import { EmptyState } from 'ui-components';

type ListingEmptyStateProps = {
  title?: string;
  description?: string;
};

export const ListingEmptyState = ({
  title = 'No results found',
  description = 'Try different keywords or remove filters',
}: ListingEmptyStateProps) => <EmptyState microcopy={{ title, description }} />;
